import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type AiActivityItem = {
  id: string;
  sessionId: string;
  userId: number;
  userDisplayName?: string;
  userAvatarUrl?: string | null;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  message?: string;
  currentStep?: string;
  progress?: number;
  filesCreated?: string[];
  filesModified?: string[];
  startedAt?: string;
  completedAt?: string;
  createdAt: string;
};

export type OutputType = {
  activities: AiActivityItem[];
  isActive: boolean;
};

export const getAiActivityStatus = async (
  params: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(params);
  const result = await fetch(
    `/_api/ai-activity/status?sessionId=${encodeURIComponent(validatedInput.sessionId)}`,
    {
      method: 'GET',
      credentials: 'include',
      ...init,
      headers: {
        'Content-Type': 'application/json',
        ...(init?.headers ?? {}),
      },
    },
  );
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
